export function toPersianDigits(n: number | string): string {
  const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
  return n.toString().replace(/\d/g, (x) => farsiDigits[parseInt(x)])
}

export function formatCurrency(amount: number): string {
  // Format with commas first, then convert to Persian digits
  const withCommas = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return `${toPersianDigits(withCommas)} ریال`
}

export function toPersianDate(dateStr: string): string {
  // Mock implementation for demo purposes - in real app use jalaali-js or similar
  // Assuming input is YYYY-MM-DD
  // This is just a placeholder mapping for the prototype
  const [year, month, day] = dateStr.split('-')
  const pYear = parseInt(year) - 621
  return toPersianDigits(`${pYear}/${month}/${day}`)
}
